import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { guideAPI } from '../../service/api';
import { FiBook } from 'react-icons/fi';
import PageMeta from '../../components/PageMeta';
import useAutoRefresh from '../../hooks/useAutoRefresh';

const categoryIcons = {
  transport: '🚌', sante: '🏥', banque: '🏦', telecom: '📱',
  logement: '🏠', administration: '📋', education: '🎓', autre: '📌',
};
const categoryLabels = {
  transport: 'Transports', sante: 'Santé', banque: 'Banques',
  telecom: 'Télécoms', logement: 'Logement', administration: 'Administration',
  education: 'Éducation', autre: 'Autre',
};

export default function GuidePage() {
  const { categorie } = useParams();
  const [articles, setArticles] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async (skipLoading = false) => {
    if (!skipLoading) setLoading(true);
    try {
      const params = categorie ? { categorie } : {};
      const [artRes, catRes] = await Promise.all([guideAPI.getAll(params), guideAPI.getCategories()]);
      setArticles(artRes.data.articles);
      setCategories(catRes.data.data || []);
    } catch (err) { console.error(err); }
    finally { if (!skipLoading) setLoading(false); }
  };

  useEffect(() => { fetchData(); }, [categorie]);
  useAutoRefresh(() => fetchData(true), 30000);

  return (
    <div className="page-container py-8">
      <PageMeta title="Guide de Kolwezi" description="Guide pratique pour votre installation à Kolwezi : transport, santé, banque, logement, administration" />
      <div className="mb-8">
        <h1 className="font-serif text-3xl font-bold tracking-tight" style={{ color: '#0A192F' }}>Guide de Kolwezi</h1>
        <p className="text-sm mt-1" style={{ color: '#7A828A' }}>Tout ce qu'il faut savoir pour votre installation</p>
      </div>

      <div className="flex flex-wrap gap-2 mb-8">
        <Link to="/guide"
          className={`px-4 py-2 text-[11px] font-bold tracking-widest uppercase border-2 transition-all ${
            !categorie ? 'bg-[#0A192F] text-white border-[#0A192F]' : 'bg-white text-[#0A192F] border-[#E5E5E0]'
          }`}>
          Tous
        </Link>
        {categories.map((cat) => (
          <Link key={cat.categorie} to={`/guide/${cat.categorie}`}
            className={`px-4 py-2 text-[11px] font-bold tracking-widest uppercase border-2 transition-all ${
              categorie === cat.categorie ? 'bg-[#0A192F] text-white border-[#0A192F]' : 'bg-white text-[#0A192F] border-[#E5E5E0]'
            }`}>
            {categoryIcons[cat.categorie] || '📌'} {categoryLabels[cat.categorie] || cat.categorie}
          </Link>
        ))}
      </div>

      {loading ? (
        <div className="flex justify-center py-20">
          <div className="animate-spin rounded-full h-8 w-8 border-2" style={{ borderColor: '#C59B6C', borderTopColor: 'transparent' }} />
        </div>
      ) : articles.length === 0 ? (
        <div className="text-center py-20">
          <FiBook className="w-16 h-16 mx-auto mb-4" style={{ color: '#E5E5E0' }} />
          <p style={{ color: '#7A828A' }}>Aucun article dans cette catégorie</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.map((article) => (
            <div key={article.id} className="card-root p-6">
              <span className="text-2xl">{categoryIcons[article.categorie] || '📌'}</span>
              <h3 className="font-serif font-bold text-base mt-3 mb-2" style={{ color: '#0A192F' }}>{article.titre}</h3>
              <p className="text-sm leading-relaxed" style={{ color: '#5A626A' }}>{article.contenu}</p>
              <div className="mt-4 pt-3 flex items-center justify-between text-xs" style={{ borderTop: '1px solid #E5E5E0', color: '#7A828A' }}>
                <span className="text-[11px] font-semibold tracking-widest uppercase">{categoryLabels[article.categorie] || article.categorie}</span>
                {article.auteurNom && <span>Par {article.auteurNom}</span>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
